<template>
  <v-card>
    <v-card-title class='body-1 fontcolor stickyHeading'>{{ADD_BULK_ADOPTION}} {{level}}: {{adoptName}}</v-card-title>
    <div class="extraHeight"></div>
    <template>
      <div class="text-right mr-4" >
      <v-btn class="mr-4" outlined dark color='red' @click='backToListingPage'>
        <v-icon dark>mdi-arrow-left</v-icon>Back to list
      </v-btn>
      <v-btn outlined class='fontcolor' @click='backToLocationProfilePage'>
        <v-icon dark>mdi-eye</v-icon>Go to profile
      </v-btn>
      </div>
      <v-radio-group style="width:50%" class="ml-3" v-model="adopFrmRdoVal" :rules="[v => !!v || 'Item is required']" required>
        <v-row no-gutters>
          <v-col >
            <v-radio color="green" name="adopFrmRdoVal" label="Add Adoption(s)" :value="1" @change="switchFrom(1)" ></v-radio>
          </v-col>
          <v-col>
            <v-radio name="adopFrmRdoVal" color="green" label="Edit Adoption(s)" :value="2" @change="switchFrom(2)" ></v-radio>
          </v-col>
        </v-row>
      </v-radio-group>
    </template>
    <template>
      <v-form
      class="ml-4 blkAdopFrm"
      id="addFormBlock"
      ref="form"
      v-model="valid"
      >
        <v-row no-gutters>
          <v-col cols='5' sm='5' md='5' lg='5' >
            <v-autocomplete
            label='Book Title (Adoption)*'
            hint='Please select code book title.'
            v-model='editedItem.codeBookId'
            :items='filterAdoptions.length >= 1 ? filterAdoptions : []'
            :rules= '[bulkAdoptionValidation]'
            item-text='titleYear'
            item-value='id'
            return-object
            class="mr-6"
            >
            </v-autocomplete>
          </v-col>
          <v-col cols='5' sm='5' md='5' lg='5' >
            <v-autocomplete
              v-model="adoptionLabelId"
              :items="adoptionLabelList"
              label="Adoption Label"
              :item-text="customAdopLabelName"
              item-value="id"
              :loading="loadingAdopLab"
              clearable
              class="mr-6"
              return-object
            >
            </v-autocomplete>
          </v-col>
          <v-col class="text-right" cols='2' sm='2' md='2' lg='2' >
            <v-btn outlined class='fontcolor mt-3' @click="addBookAndLabel" ><v-icon dark>mdi-plus</v-icon>Add</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-simple-table v-if="bookAndLabelArrVal.length > 0" dense >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Book Title</th>
                      <th class="text-left">Adoption Label</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in bookAndLabelArrVal" :key="item.bookId">
                      <td>{{ item.bookName }}</td>
                      <td>
                        <span v-if="item.labelName" >{{ item.labelName }}({{ item.pubAcronym }})</span>
                      </td>
                      <td>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" color="red" style="cursor:pointer" text small @click="removeBookFromList(item.bId)" >mdi-delete</v-icon>
                          </template>
                          <span>Delete Row</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <p v-else >Select Book Title and Adoption Label ( <v-icon class="mb-2" dense medium >mdi-gesture-swipe-up</v-icon>) and click on ADD button.</p>
          </v-col>
        </v-row>
        <v-row no-gutters >
          <v-col>
            <v-select
              label='Adoption Status*'
              :items="STATUS_FIELD"
              v-model="DEFAULT_ADOPTION_STATUS_FIELD_VALUE"
              :rules="bulkAdoptionStatusRules"
              clearable
            >
            </v-select>
          </v-col>
        </v-row>
        <v-row no-gutters >
          <v-col>
            <v-select
              label='Adoption Type*'
              :items="DEFAULT_ADOPTION_TYPE_FIELD"
              v-model="DEFAULT_ADOPTION_TYPE_FIELD_VALUE"
              :rules="bulkAdoptionTypeRules"
              clearable
            >
            </v-select>
          </v-col>
        </v-row>
        <v-row no-gutters >
          <v-col>
            <v-menu
              ref='menu'
              v-model='menu'
              :close-on-content-click='false'
              :return-value.sync='editedItem.date'
              transition='scale-transition'
              offset-y
              min-width='290px'
            >
              <template v-slot:activator='{ on }'>
                <v-text-field
                  v-model='editedItem.effectiveDate'
                  label='Effective Date'
                  readonly
                  prepend-icon='mdi-calendar'
                  v-on='on'
                  clearable
                ></v-text-field>
              </template>
              <v-date-picker
                v-model='editedItem.effectiveDate'
                hint=' Please select an Effective Date'
                persistent-hint
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn text color='error' @click='menu = false'>Cancel</v-btn>
                <v-btn text color='success' @click='$refs.menu.save(editedItem.date)'>OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
          <v-btn outlined class='fontcolor' @click="SaveMultiAdoptionBtn" >
            <v-icon >mdi-check</v-icon>Add Adoption(s)
          </v-btn>
          </v-card-actions>
      </v-form>
    </template>
    <template>
      <v-form class="ml-4 blkAdopFrm" id="editFormBlock" style="display:none;" ref='forms' v-model='valids'>
        <v-row>
          <v-col>
            <v-alert
              outlined
              color="#0b5940"
              icon="mdi-information"
              dense
              text>
               Note: The changes will be applied to any titles with the checkbox selected from adoption list below.
            </v-alert>
          </v-col>
        </v-row>
        <v-row no-gutters >
          <v-col>
            <v-select
              :disabled="checkIsSelected"
              label='Adoption Status'
              :items="STATUS_FIELD"
              v-model="DEFAULT_ADOPTION_STATUS_FIELD_VALUE"
              clearable
            >
            </v-select>
          </v-col>
        </v-row>
        <v-row no-gutters >
          <v-col>
            <v-select
              :disabled="checkIsSelected"
              label='Adoption Type'
              :items="DEFAULT_ADOPTION_TYPE_FIELD"
              v-model="DEFAULT_ADOPTION_TYPE_FIELD_VALUE"
              clearable
            >
            </v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-autocomplete
              :disabled="checkIsSelected"
              v-model="adoptionLabelId"
              :items="adoptionLabelList"
              label="Adoption Label"
              :item-text="customAdopLabelName"
              item-value="id"
              dense
              :loading="loadingAdopLab"
              clearable
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row no-gutters >
          <v-col>
            <v-menu
              ref='menu2'
              v-model='menu2'
              :close-on-content-click='false'
              :return-value.sync='editedItem.date'
              transition='scale-transition'
              offset-y
              min-width='290px'
            >
              <template v-slot:activator='{ on }'>
                <v-text-field
                  :disabled="checkIsSelected"
                  v-model='editedItem.effectiveDate'
                  label='Effective Date'
                  readonly
                  prepend-icon='mdi-calendar'
                  v-on='on'
                  clearable
                ></v-text-field>
              </template>
              <v-date-picker
                v-model='editedItem.effectiveDate'
                hint=' Please select an Effective Date'
                persistent-hint
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn text color='error' @click='menu2 = false'>Cancel</v-btn>
                <v-btn text color='success' @click='$refs.menu2.save(editedItem.date)'>OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-card-actions >
          <v-spacer></v-spacer>
          <v-btn :disabled="checkIsSelected" outlined class='fontcolor' @click="changeStatusBtn">
            <v-icon >mdi-check</v-icon>
            Update Adoption(s)
          </v-btn>
        </v-card-actions>
      </v-form>
    </template>
      <v-layout column class="styleHeight">
        <v-flex class="flexBasis" md6 style="overflow: auto">
        <v-data-table
          v-model='selected'
          :headers='headers'
          :items='adoptions'
          :single-select='singleSelect'
          item-key='id'
          show-select
          class='elevation-1'
          hide-default-footer
          :disable-pagination="true"
        >
          <template v-slot:top>
            <v-toolbar flat id='manageTable'>
              <v-toolbar-title class='display-1 fontcolor'>{{TABLE_TITLE}}</v-toolbar-title>
            </v-toolbar>
          </template>
          <template v-slot:item.bookTitleYear="{ item }">
            <span v-if="typeof item.customBookTitleYear !== 'undefined' && item.customBookTitleYear !== ''">{{ item.customBookTitleYear }}</span>
            <span v-else >{{ item.bookTitleYear }}</span>
          </template>
          <template v-slot:no-data>
            <p>{{NO_DATA_FOUND}}</p>
          </template>
        </v-data-table>
        </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import CONSTANTS from './../../../../config/constant'

export default {
  name: 'BulkAdoption',
  data: () => ({
    existingMappedAdoptions: [],
    bookAndLabelArr: [],
    loadingAdopLab: true,
    adoptionLabelId: '',
    adopLabList: [],
    adopFrmRdoVal: 1,
    TABLE_TITLE: 'Adoptions',
    ADD_NEW_ADOPTION: CONSTANTS.ADD_ADOPTION,
    NO_DATA_FOUND: CONSTANTS.NO_DATA_FOUND,
    STATUS_FIELD: CONSTANTS.ADOPTION_STATUS_FIELD,
    DEFAULT_ADOPTION_TYPE_FIELD: CONSTANTS.ADOPTION_TYPE_FIELD,
    DEFAULT_ADOPTION_TYPE_FIELD_VALUE: CONSTANTS.DEFAULT_ADOPTION_TYPE_FIELD_VALUE,
    DEFAULT_ADOPTION_STATUS_FIELD_VALUE: CONSTANTS.DEFAULT_ADOPTION_STATUS_FIELD_VALUE,
    ADD_BULK_ADOPTION: CONSTANTS.ADD_BULK_ADOPTION,
    defaultPagination: true,
    level: '',
    entityId: '',
    entityLevel: '',
    entityLevelId: '',
    entityName: '',
    valid: true,
    valids: true,
    singleSelect: false,
    menu: false,
    menu2: false,
    selected: [],
    disableStatusUpdateField: true,
    bulkAdoptionRules: [
      v => !!v || 'Book Title is required.'],
    bulkAdoptionStatusRules: [
      v => !!v || 'Adoption Status is required.'],
    bulkAdoptionTypeRules: [
      v => !!v || 'Adoption Type is required.'],
    editedItem: {
      codeBookId: [],
      effectiveDate: ''
    },
    headers: [
      {
        text: 'Book Title',
        value: 'bookTitleYear',
        sortable: false,
        class: 'subtitle-2'
      },
      {
        text: 'Effective Date',
        value: 'effectiveDate',
        sortable: false,
        class: 'subtitle-2'
      },
      {
        text: 'Adoption Type',
        value: 'adoptionType',
        sortable: false,
        class: 'subtitle-2'
      },
      {
        text: 'Adoption Status',
        value: 'adoptionStatus',
        sortable: false,
        class: 'subtitle-2'
      },
      {
        text: 'Adoption Label',
        value: 'adoptionLabel',
        sortable: false,
        class: 'subtitle-2'
      }
    ],
    defaultItem: {
      codeBookId: [],
      effectiveDate: ''
    }
  }),
  mounted () {
    if (this.$route.params.adoptionLevel === 'jurisdictions') {
      this.level = 'Jurisdiction'
      this.entityLevelId = 3
    } else if (this.$route.params.adoptionLevel === 'counties') {
      this.level = 'County'
      this.entityLevelId = 2
    } else if (this.$route.params.adoptionLevel === 'states') {
      this.level = 'State'
      this.entityLevelId = 1
    } else if (this.$route.params.adoptionLevel === 'townships') {
      this.level = 'Township'
      this.entityLevelId = 4
    }
    this.entityId = this.$route.params.id
    this.entityLevel = this.$route.params.adoptionLevel

    this.$refs.form.reset()
    this.$refs.form.resetValidation()
    this.initialize()
  },
  computed: {
    // to get logged in user ID
    userId () {
      return this.$store.getters['AuthModule/getUserId']
    },
    // to fetch adoption list
    adoptions () {
      return this.$store.getters['AdoptionModule/fetchMappedAdoptionList']
    },
    adoptionLevel () {
      return this.$store.getters['AdoptionModule/fetchAdoptionLevel']
    },
    adoptionLevelFor () {
      return this.$store.getters['AdoptionModule/fetchAdoptionLevelFor']
    },
    // to fetch code book list
    codebooks () {
      return this.$store.getters['CodeBookModule/fetchCodeBookList']
    },
    adoptName () {
      return this.entityName
    },
    filterAdoptions () {
      return this.codebooks
      /* let array1 = this.codebooks.map(item => item)
      if (this.adoptions.length > 0) {
        let array2 = this.adoptions.map(el => el.codeBookId)
        let ress = array2 === null ? null : array1.filter(val => !array2.includes(val.id))
        let result = ress.length > 0 ? ress : ''
        return result
      } else {
        return this.codebooks
      } */
    },
    checkIsSelected () {
      return this.selected.length > 0 ? !this.disableStatusUpdateField : this.disableStatusUpdateField
    },
    adoptionLabelList () {
      return this.adopLabList
    },
    bookAndLabelArrVal () {
      return this.bookAndLabelArr
    }
  },
  methods: {
    removeBookFromList (idToRm) {
      if (idToRm !== '') {
        let removeIndex = this.bookAndLabelArr.map(function (item) { return item.bId }).indexOf(idToRm)
        // remove object
        this.bookAndLabelArr.splice(removeIndex, 1)
      }
    },
    addBookAndLabel () {
      let combineArray = []
      // this array will be combination
      combineArray = this.existingMappedAdoptions.concat(this.bookAndLabelArr)
      if (typeof this.editedItem.codeBookId.id === 'undefined') {
        return false
      }
      let isValidToPush = true
      let checkFor = this.editedItem.codeBookId.id
      let checkForLabelId = ''
      if (this.adoptionLabelId !== undefined && this.adoptionLabelId !== '') {
        checkForLabelId = this.adoptionLabelId.id
      }
      // get the exiting adoption details
      for (let itm in combineArray) {
        if (checkForLabelId !== '') {
          if (combineArray[itm]['bId'] === checkFor && combineArray[itm]['lId'] === checkForLabelId) {
            isValidToPush = false
            break
          }
        } else {
          if (combineArray[itm]['bId'] === checkFor && combineArray[itm]['lId'] === '') {
            isValidToPush = false
            break
          }
        }
      }
      if (isValidToPush === false) {
        this.$globalStates.notification.type = 'error'
        this.$globalStates.notification.text = 'The selected Book Title and Code Adoption already exist'
        this.$globalStates.notification.init_notifications = true
      }
      if (this.editedItem.codeBookId !== '' && isValidToPush) {
        let selectedRowArr = []
        let cbArr = {}
        let labelName = ''
        let labelId = ''
        let pubAcronym = ''
        if (this.adoptionLabelId !== undefined && this.adoptionLabelId !== '') {
          labelName = this.adoptionLabelId.adoptionLabel
          labelId = this.adoptionLabelId.id
          pubAcronym = this.adoptionLabelId.publisherAcronym
        }
        cbArr = {
          'bookName': this.editedItem.codeBookId.titleYear,
          'bId': this.editedItem.codeBookId.id,
          'labelName': labelName,
          'lId': labelId,
          'pubAcronym': pubAcronym
        }
        selectedRowArr = cbArr
        this.bookAndLabelArr.push(selectedRowArr)
        selectedRowArr = []
        cbArr = {}
        this.editedItem.codeBookId = ''
        this.adoptionLabelId = ''
      }
    },
    customAdopLabelName: item => item.adoptionLabel + ' (' + item.publisherAcronym + ')',
    // dispatch an action in below method to fetch adoption list
    initialize () {
      // fetch location detail by Id based on level and id
      let idToGetInfo = ''
      if (this.entityLevel === 'states') {
        idToGetInfo = this.entityId
        // Fetch data by id for edit
        new Promise((resolve, reject) => {
          this.$store.dispatch('StateModule/getStateDetailsById', { resolve, reject, idToGetInfo })
        }).then((responseData) => {
          this.entityName = responseData.list[0].name
        }).catch(({ response }) => {
        })
      }
      if (this.entityLevel === 'counties') {
        idToGetInfo = this.entityId
        // Fetch data by id for edit
        new Promise((resolve, reject) => {
          this.$store.dispatch('CountyModule/getCountyDetailsById', { resolve, reject, idToGetInfo })
        }).then((responseData) => {
          this.entityName = responseData.list[0].name
        }).catch(({ response }) => {
        })
      }
      if (this.entityLevel === 'jurisdictions') {
        idToGetInfo = this.entityId
        // Fetch data by id for edit
        new Promise((resolve, reject) => {
          this.$store.dispatch('JurisdictionModule/getJurisdictionDetailsById', { resolve, reject, idToGetInfo })
        }).then((responseData) => {
          this.entityName = responseData.list[0].name
        }).catch(({ response }) => {
        })
      }
      if (this.entityLevel === 'townships') {
        idToGetInfo = this.entityId
        // Fetch data by id for edit
        new Promise((resolve, reject) => {
          this.$store.dispatch('TownshipModule/getTownshipDetailsById', { resolve, reject, idToGetInfo })
        }).then((responseData) => {
          this.entityName = responseData.list[0].name
        }).catch(({ response }) => {
        })
      }
      // dispatch an action in below method to fetch codebook list
      new Promise((resolve, reject, status = 2) => {
        this.$store.dispatch('CodeBookModule/getCodeBookList', {
          resolve,
          reject,
          status
        })
      })
        .then(responseData => {})
        .catch(response => {})
      let adoptionLevel = null
      adoptionLevel = this.entityLevelId
      let adoptionLevelFor = this.$route.params.id
      new Promise((resolve, reject) => {
        this.$store.dispatch('AdoptionModule/getMappedAdoptionList', {
          resolve,
          reject,
          adoptionLevel,
          adoptionLevelFor
        })
      })
        .then(responseData => {
          // generate the object of exsiting adoption
          let existingAdoptions = responseData.list
          for (let x in existingAdoptions) {
            let orgArr = []
            orgArr = {
              'bookName': existingAdoptions[x]['codeBookName'],
              'bId': existingAdoptions[x]['codeBookId'],
              'labelName': existingAdoptions[x]['adoptionLabelText'],
              'lId': existingAdoptions[x]['adoptionLabelId'],
              'pubAcronym': existingAdoptions[x]['publisherAcronym']
            }
            this.existingMappedAdoptions.push(orgArr)
          }
        })
        .catch(response => {})
      new Promise((resolve, reject, status = 2) => {
        this.$store.dispatch('AdoptionLabelModule/getAdoptionLabelList', {
          resolve,
          reject,
          status
        })
      })
        .then(responseData => {
          this.adopLabList = responseData.list
          this.loadingAdopLab = false
        })
        .catch(response => {
          this.loadingAdopLab = false
        })
    },
    // remove chips from book title field
    remove (item) {
      const index = this.editedItem.codeBookId.indexOf(item.item.id)
      if (index >= 0) this.editedItem.codeBookId.splice(index, 1)
    },
    closeDialog () {
      this.editedItem = Object.assign({}, this.defaultItem)
      this.singleSelect = false
      this.selected = []
      this.DEFAULT_ADOPTION_STATUS_FIELD_VALUE = CONSTANTS.DEFAULT_ADOPTION_STATUS_FIELD_VALUE
      this.DEFAULT_ADOPTION_TYPE_FIELD_VALUE = CONSTANTS.DEFAULT_ADOPTION_TYPE_FIELD_VALUE
      this.editedItem.effectiveDate = ''
      this.adoptionLabelId = ''
      this.$refs.form.reset()
      this.$refs.form.resetValidation()
    },
    // Change Adoption Status method
    changeStatusBtn () {
      if (this.$refs.forms.validate()) {
        let statusField = ''
        if (this.DEFAULT_ADOPTION_STATUS_FIELD_VALUE === 'Past Adoption') {
          statusField = 2
        }
        if (this.DEFAULT_ADOPTION_STATUS_FIELD_VALUE === 'Current Adoption') {
          statusField = 1
        }
        let effectiveDate = typeof (this.editedItem.effectiveDate) === 'undefined' ? '' : this.editedItem.effectiveDate
        let getAdoptionType = CONSTANTS.DEFAULT_ADOPTION_TYPE_FIELD_VALUE[this.DEFAULT_ADOPTION_TYPE_FIELD_VALUE]
        let adoptionType = typeof getAdoptionType !== 'undefined' ? getAdoptionType : ''
        let adoptionLabelId = this.adoptionLabelId
        let id = []
        this.selected.map(item => {
          id.push(item.id)
        })
        const formData = {
          id: id,
          status: statusField,
          userId: this.userId,
          effectiveDate: effectiveDate,
          adoptionType: adoptionType,
          adoptionLabel: adoptionLabelId
        }
        new Promise((resolve, reject) => {
          this.$store.dispatch('AdoptionModule/changeAdoptionStatusItems', {
            resolve,
            reject,
            formData
          })
        })
          .then(responseData => {
            this.$globalStates.notification.type = 'green'
            this.$globalStates.notification.text = responseData.responseMessage
            this.$globalStates.notification.init_notifications = true
            this.closeDialog()
            let adoptionLevel = null
            adoptionLevel = this.entityLevelId
            let adoptionLevelFor = this.$route.params.id
            new Promise((resolve, reject) => {
              this.$store.dispatch('AdoptionModule/getMappedAdoptionList', {
                resolve,
                reject,
                adoptionLevel,
                adoptionLevelFor
              })
            })
              .then(responseData => {})
              .catch(response => {})
          })
          .catch(response => {
            this.$globalStates.notification.type = 'error'
            this.$globalStates.notification.text = response.responseMessage
            this.$globalStates.notification.init_notifications = true
          })
      }
    },
    SaveMultiAdoptionBtn () {
      if (this.$refs.form.validate()) {
        /* eslint-disable no-unused-vars */
        let statusField = ''
        if (this.DEFAULT_ADOPTION_STATUS_FIELD_VALUE === 'Past Adoption') {
          statusField = 2
        }
        if (this.DEFAULT_ADOPTION_STATUS_FIELD_VALUE === 'Current Adoption') {
          statusField = 1
        }
        let effectiveDate = typeof (this.editedItem.effectiveDate) === 'undefined' ? '' : this.editedItem.effectiveDate
        let getAdoptionType = CONSTANTS.DEFAULT_ADOPTION_TYPE_FIELD_VALUE[this.DEFAULT_ADOPTION_TYPE_FIELD_VALUE]
        let adoptionType = typeof getAdoptionType !== 'undefined' ? getAdoptionType : ''
        let bookIdsList = ''
        let labelIdsList = ''
        for (let x in this.bookAndLabelArr) {
          bookIdsList = (bookIdsList !== '') ? bookIdsList + ',' + this.bookAndLabelArr[x]['bId'] : this.bookAndLabelArr[x]['bId']
          if (this.bookAndLabelArr[x]['lId'] !== '') {
            labelIdsList = (labelIdsList !== '') ? labelIdsList + ',' + this.bookAndLabelArr[x]['lId'] : this.bookAndLabelArr[x]['lId']
          } else {
            labelIdsList = (labelIdsList !== '') ? labelIdsList + ',' + 0 : 0
          }
        }
        const formData = {
          bookIds: bookIdsList,
          adoptionLabelIds: labelIdsList,
          userId: this.userId,
          adoptionLevel: this.entityLevelId,
          id: this.entityId,
          adoptionStatus: statusField,
          adoptionType: adoptionType,
          effectiveDate: effectiveDate
        }
        new Promise((resolve, reject) => {
          this.$store.dispatch('AdoptionModule/addBulkAdoptions', {
            resolve,
            reject,
            formData
          })
        })
          .then(responseData => {
            this.$globalStates.notification.type = 'green'
            this.$globalStates.notification.text = responseData.responseMessage
            this.$globalStates.notification.init_notifications = true
            this.closeDialog()
            let adoptionLevel = null
            adoptionLevel = this.entityLevelId
            let adoptionLevelFor = this.$route.params.id
            this.bookAndLabelArr = []
            new Promise((resolve, reject) => {
              this.$store.dispatch('AdoptionModule/getMappedAdoptionList', {
                resolve,
                reject,
                adoptionLevel,
                adoptionLevelFor
              })
            })
              .then(responseData => {})
              .catch(response => {})
          })
          .catch(response => {
            this.$globalStates.notification.type = 'error'
            this.$globalStates.notification.text = response.responseMessage
            this.$globalStates.notification.init_notifications = true
          })
      }
    },
    switchFrom (selectedVal) {
      switch (selectedVal) {
        case 1:
          document.getElementById('editFormBlock').style.display = 'none'
          document.getElementById('addFormBlock').style.display = 'block'
          break
        case 2:
          document.getElementById('addFormBlock').style.display = 'none'
          document.getElementById('editFormBlock').style.display = 'block'
          // code block
          break
        default:
          // code block
      }
    },
    /**
     * Function to send user back to edit page
     */
    backToListingPage () {
      if (this.entityLevel === 'states') {
        this.$router.push({ name: 'AdminStates' })
      }
      if (this.entityLevel === 'counties') {
        this.$router.push({ name: 'AdminCounties' })
      }
      if (this.entityLevel === 'jurisdictions') {
        this.$router.push({ name: 'AdminJurisdictions' })
      }
      if (this.entityLevel === 'townships') {
        this.$router.push({ name: 'AdminTownships' })
      }
    },
    bulkAdoptionValidation (v) {
      if (!v && this.bookAndLabelArr.length <= 0) {
        return 'Book Title is required.'
      } else {
        return true
      }
    },
    backToLocationProfilePage () {
      if (this.entityLevel === 'states') {
        this.$router.push({ name: 'AdminEditState', params: { id: this.entityId, tabId: 1 } })
      }
      if (this.entityLevel === 'counties') {
        this.$router.push({ name: 'AdminEditCounty', params: { id: this.entityId, tabId: 1 } })
      }
      if (this.entityLevel === 'jurisdictions') {
        this.$router.push({ name: 'AdminEditJurisdiction', params: { id: this.entityId, tabId: 1 } })
      }
      if (this.entityLevel === 'townships') {
        this.$router.push({ name: 'AdminEditTownship', params: { id: this.entityId, tabId: 1 } })
      }
    }
  }
}
</script>
